import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { PrePaymentReportFormModel } from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): PrePaymentReportFormModel => ({
  from: globalSettings?.frontend_date,
  to: globalSettings?.frontend_date,
  cash_register_ids: null,
  cashier_ids: null,
  file_type: 'pdf',
  total_grouped: true,
});
